<template>

    <v-app id="app" :class="[{'collapsed' : collapsed}, {'noSideBar' : isLoginResPage || isSetupPage || isTripInfoPage}]" >


        <v-dialog content-class="supportDialog"
                v-model="helpDialog"
                max-width="300"
        >
            <v-card>
                <v-card-title >
                    <span class="headline" style="width: 100%">Need Help?</span>
                    <span  style="width: 100%">Our support hours are {{supportTimes}} Monday - Friday</span>
                </v-card-title>
<v-divider></v-divider>
                <v-card-text style="text-align: left;     padding-bottom: 0;">
                    <p><v-icon color="primary" style="vertical-align: middle;">phone</v-icon> <a  target="_blank" href="tel:1-952-898-3478">952-898-3478</a></p>
                    <p><v-icon  color="primary" style="vertical-align: middle;">email</v-icon> <a  target="_blank" :href="this.$userData.supportLink">Click To Email Us</a> </p>
             <p><b>Please include your School Name or Trip ID with your message, Thank You!</b></p>

                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>


                    <v-btn
                            color="primary"
                            flat="flat"
                            @click="helpDialog = false"
                    >
                        Close
                    </v-btn>

                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog content-class="busyDialog"
                  v-model="$busyDialog"
                   persistent
                  max-width="300"
        >
            <v-card>

                <v-card-text>
                    <v-progress-circular
                            :size="50"
                            color="primary"
                            indeterminate
                    ></v-progress-circular>


                    <span style="padding-left: 10px !important;">One moment...</span>

                </v-card-text>

            </v-card>
        </v-dialog>

        <div class="headerBarWrapper" v-if="!isLoginResPage  && !isSetupPage && !isTripInfoPage">

        <sidebar-menu ref="sidebar" id="pageSidebar" width="300px" :collapsed="collapsed" @collapse="onCollapse" :menu="menu" />

        <div id="appHeader">


            <v-layout row class="profileActions">

                <v-flex xs7 style="text-align: left;">
                    <v-btn class="supportButton" @click.stop="helpDialog = true" color="primary">
                        <v-icon>contact_support</v-icon> Support
                    </v-btn>
                </v-flex>
                <v-flex xs5>
                <v-menu style="float: right;" offset-y>
                    <template>

                            <v-list dense style="background-color: transparent;"
                                    slot="activator">
                                <v-list-tile>

                                    <v-list-tile-content>
                                        <v-list-tile-title>{{$userData.firstName + ' ' + $userData.lastName }}</v-list-tile-title>
                                        <v-list-tile-sub-title>{{$userData.permissions[0]}}</v-list-tile-sub-title>
                                    </v-list-tile-content>

                                    <v-list-tile-avatar>
                                        <v-icon  color="primary">arrow_drop_down_circle</v-icon>
                                    </v-list-tile-avatar>
                                </v-list-tile>
                            </v-list>
                    </template>
                    <v-list >
                        <v-list-tile
                                v-for="(item, index) in profile_actions"
                                :key="index"
                                @click="handleProfileLinks(index)"
                        >
                            <v-list-tile-title>{{ item }}</v-list-tile-title>
                        </v-list-tile>
                    </v-list>
                </v-menu>
                </v-flex>
            </v-layout>

        </div>
        </div>
        <div :class="[{'pageContentWrapper' : !isLoginResPage}, {'formPageWrapper' : (isLoginResPage && !isTripInfoPage)}]"  >
            <v-alert class="pageAlertBar" v-if="updateResult != null && updateMessage != null"
                     :value="true"
                     dismissible
                     :type="updateResult"
                     transition="scale-transition"
            >
                {{updateMessage}}
            </v-alert>
            <router-view  :key="$route.fullPath" v-on:alertUser="alertUser"></router-view>

            <p v-if="!isLoginResPage && this.$structuredData != undefined">Last Refresh: {{this.$structuredData.time}}</p>
        </div>
    </v-app>
</template>

<script>
    import moment from'moment';
    export default {
        name: 'app',
        created() {
        },
        mounted() {

            if(window.innerWidth > 480) {
           //     this.$refs.sidebar.toggleCollapse()
            }

            this.updateData(true)


            setInterval(() => this.updateData(), 10000); // check for updated data every 10 seconds!




        },
        components: {
          //  CreditCardField: () => import(/* webpackChunkName: "vue-credit-card-field" */'vue-credit-card-field/src/Components/CreditCardField')
        },
        methods: {
            updateData(){
                if(this.$feathers.get('user') !== undefined) {
                    this.$userData.permissions = this.$feathers.get('user').permissions
                    this.$userData.firstName = this.$feathers.get('user').firstName
                    this.$userData.lastName = this.$feathers.get('user').lastName

                    this.$fetchData()


                }
            },
            alertUser(result, message) {
                console.log('allert user called', result, message)
                this.showUpdateAlert = false;
                this.updateMessage = null
                this.updateResult = null
                setTimeout(() => {
                    this.updateMessage = message
                    this.updateResult = result
                    if(result =="error" && message === undefined) {
                        this.updateMessage = "Sorry, there was an error processing your request. Please try again later."
                    }
                    this.showUpdateAlert = true;
                }, 1)

            },
            onCollapse(val) {
                this.collapsed = val
            },
            handleProfileLinks(index) {
                console.log('in handle profile links')
                if(index == 0) { // Profile

                this.$router.push('/Profile')

                } else if (index == 1) { // Log Out
                    this.$feathers.logout()
                    this.$cookies.remove("tripToAdd");
                    this.$router.push('/Login')
                    this.$router.go(0);
                } else if (index == 2) {
                  this.$router.push('/SelectTrip')
                }
            }
        },
        computed: {
            // a computed getter
            supportTimes() {
                var today = new Date();
                var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();

                var toReturn = moment(moment.utc(date + " 3:00:00")).local().format("h") + 'am - ' + moment(moment.utc(date + " 10:30:00")).local().format("h:mm") + 'pm'

                return toReturn


            },
            menu: function () {
                return [
                    {
                        header: true,
                        title: 'Group Travel Planners',
                        //component:
                    },
                    {
                        href: '/',
                        title: 'Dashboard (' + this.dashboardBadge + ')',
                        icon: 'fa fa-user',
                        //disabled: true
                        //badge: {
                           // text: this.dashboardBadge,
                            // class:''
                       // }
                    },
                    {
                        title: 'Trips',
                        icon: 'fas fa-plane',
                        disabled: this.isCustomer,
                        child: [
                            {
                                href: '/Trips',
                                title: 'All Trips',
                            },
                            {
                                href: '/NewTrip',
                                title: 'Add New',
                                disabled: !this.isAdmin,
                            }
                        ]
                    },
                    {
                        icon: 'fas fa-plane',
                        disabled: !this.isCustomer,
                        href: '/Trips',
                        title: 'My Trips',
                    },
                    {
                        title: 'Businesses',
                        icon: 'fas fa-building',
                        disabled: !this.isAdmin,
                        child: [
                            {
                                href: '/Businesses',
                                title: 'All Businesses',
                            },
                            {
                                href: '/AddBusiness',
                                title: 'Add New',
                            }
                        ]
                    },
                    {
                        href: '/Users',
                        title: 'Users',
                        icon: 'fas fa-users-cog',
                        disabled: this.isCustomer
                    },
                    {
                        href: '/Participants',
                        title: 'Participants',
                        icon: 'fas fa-bed',
                        disabled: this.isCustomer
                    },
                    {
                        href: '/Participants',
                        title: 'My Participants',
                        icon: 'fas fa-bed',
                        disabled: !this.isCustomer
                    },
                    {
                        href: '/Documents',
                        title: 'Documents',
                        icon: 'fas fa-file',
                        disabled: this.isAdmin
                    },
                    {
                        href: '/Forms',
                        title: 'Forms',
                        icon: 'fas fa-file',
                        disabled: !this.isAdmin
                    },
                    {
                        href: '/Reports',
                        title: 'Reports',
                        disabled: this.isCustomer,
                        icon: 'fas fa-file-invoice'
                    },
                    {
                        href: '/Payments',
                        title: 'Payments',
                        icon: 'fas fa-credit-card'
                    },
                    {
                        href: '/TripNews',
                        title: 'Notifications / Updates',
                        icon: 'fas fa-envelope'
                    }
                ]
            },

            dashboardBadge: function() {
                if (this.$userData.permissions[0] == 'admin')
                    return 'ADMIN'
                    else if (this.$userData.permissions[0] == 'director')
                        return 'DIRECTOR'
                    else if (this.$userData.permissions[0] == 'adult') {
                        return 'USER'
                    }
                    else if (this.$userData.permissions[0] == 'sales') {
                      return 'SALES'
                    }
                    else {
                        return 'TRAVELER'
                    }

            },
            isCustomer: function () {
                if (this.$userData.permissions[0] == 'sales' || this.$userData.permissions[0] == 'admin' || this.$userData.permissions[0] == 'director') {
                    return false
                } else {
                    console.log('THIS IS A CUSTOMER')
                    this.profile_actions.push('Select Trip')
                    return true
                }
            },
            isAdmin: function () {
                console.log('in is admin!!!!!!!!!', this.$userData )
                return (this.$userData.permissions.includes('admin') || this.$userData.permissions.includes('sales'))
            },
            isLoginResPage: function () {
                console.log(this.$route.name)

                if (['login', 'register', 'recovery', 'verify', 'connecting'].includes(this.$route.name)) {
                    return true;
                } else {
                    return false;
                }
            },
          isTripInfoPage: function () {
            console.log(this.$route.name)

            if (['tripinfo'].includes(this.$route.name)) {
              return true;
            } else {
              return false;
            }
          },
            isSetupPage: function () {

                if (['setup'].includes(this.$route.name)) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        data() {
            return {
                helpDialog: false,
                showUpdateAlert: false,
                updateMessage: null,
                updateResult: null,
                profile_actions: ['Profile', 'Log Out'],
                authenticated: false,
                collapsed: true,

            }
        }
    }
</script>

<style>

    .v-sidebar-menu .vsm-link[disabled] {
        display: none;
    }
    .headerBarWrapper{
        margin-bottom: 5px;
        background-color: #ffffff;
        box-shadow: 0 2px 5px 0 rgba(0,0,0,0.16), 0 2px 10px 0 rgba(0,0,0,0.12);

    }

    .supportButton{
        margin-left: 30px;
    }

    .pageAlertBar {
        font-size: 20px;
        color: black;
        font-weight: 900;
        margin-top: 0;
        margin-bottom: 0;
        position: sticky;
        top: 0;
        z-index: 7;
    }

    .mainSectionHeadingInList{
        background: #ededed;
        border-bottom: black 1px solid;
    }
    .mainSectionHeadingInList .v-list__tile__title {
        color: black;
        font-size: 20px;
    }
    .mainSectionHeadingInList .v-icon {
        font-size: 30px;
    }


    #pageSidebar {
        z-index: 900
    }


    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
    }
    #app {
        margin-left: 300px;
    }
    #app.collapsed {
        margin-left: 50px;
    }
    #app.noSideBar {
        margin-left: 0 !important;
        background: url("assets/background.jpeg");
        background-repeat: no-repeat;
        background-size: cover;
        background-position-y: bottom;
    }

    @media (min-width: 320px) and (max-width: 480px) {

        .supportDialog, .busyDialog {

            position: relative;
            right: 35px;
        }

        .busyDialog {
            border-radius: 10px;
        }
        .supportButton{
            margin-left: 60px;
        }

      #app:not(.noSideBar) .pageContentWrapper{
            margin-left: 50px;
        }

        .pageHeading h1, .pageHeading h2 {

            padding-left: 10px;
        }

    #pageSidebar {

    }

        #app {
            margin: 0 !important;
        }

        .pageContentWrapper section{
            margin: 0 !important;;
            padding: 10px 0px !important;;
        }

    }



    .pageContentWrapper section {
        margin: 15px;
        margin-top: 0px;
        height: 100%;
        padding: 10px 17px;
        background: #fff;
        border: 1px solid #E6E9ED;
    }

    .formPageWrapper  {

        padding: 10px 17px;
        background: #fff;
        border: 1px solid #E6E9ED;
        width: 350px !important;
        margin-left: auto;
        margin-top: auto;
        margin-bottom: auto;
        margin-right: auto;

    }
    #appHeader {
        /*height: 60px;*/
        background-color: rgb(237, 237, 237);
    }
    body {
        margin: 0px !important;
        background-color: rgb(247, 247, 247);
    }
    .pageHeading {
        border-bottom: black 2px solid;
        text-align: left;
        margin-bottom: 10px;
    }
    .pageHeading h2 {
        display: inline-block;
    }


    .fullWidthTable {
        min-width: 100% !important;
    }
    .fullWidthTableFilter {
        float: right;
        border: black 1px solid;
        padding: 2px;
    }
    .fullWidthTable tbody tr:nth-child(even){
        background: #f7f5f5;
    }
    .fullWidthTable tbody tr:nth-child(odd){
        background: #e5e5e5;
    }
    #appHeader .profileActions {
        z-index: 99999;
        background-color: white !important;
        /* float: right;
        display: inline-block;
        min-width: 150px; */
    }
    #appHeader .profileActions > * {
        margin-top: 0;
    }


    .errorShake {
        -webkit-animation: kf_shake 0.4s 1 linear;
        -moz-animation: kf_shake 0.4s 1 linear;
        -o-animation: kf_shake 0.4s 1 linear;
    }
    @-webkit-keyframes kf_shake {
        0% { -webkit-transform: translate(30px); }
        20% { -webkit-transform: translate(-30px); }
        40% { -webkit-transform: translate(15px); }
        60% { -webkit-transform: translate(-15px); }
        80% { -webkit-transform: translate(8px); }
        100% { -webkit-transform: translate(0px); }
    }
    @-moz-keyframes kf_shake {
        0% { -moz-transform: translate(30px); }
        20% { -moz-transform: translate(-30px); }
        40% { -moz-transform: translate(15px); }
        60% { -moz-transform: translate(-15px); }
        80% { -moz-transform: translate(8px); }
        100% { -moz-transform: translate(0px); }
    }
    @-o-keyframes kf_shake {
        0% { -o-transform: translate(30px); }
        20% { -o-transform: translate(-30px); }
        40% { -o-transform: translate(15px); }
        60% { -o-transform: translate(-15px); }
        80% { -o-transform: translate(8px); }
        100% { -o-origin-transform: translate(0px); }
    }


</style>
